// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DGFFV","label":"styles_label__2oJr6"};